// extracted by mini-css-extract-plugin
export default {"main":"Main_main__JAaVz","flareAnimation":"Main_flareAnimation__k3bEA"};